import { render, staticRenderFns } from "./PrivilegesSidebar.vue?vue&type=template&id=7735fd47&"
import script from "./PrivilegesSidebar.vue?vue&type=script&lang=js&"
export * from "./PrivilegesSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports